import React from 'react';
import styled from '@emotion/styled';
import { AtlassianLogo } from '@atlaskit/logo';
import { B200, B400 } from '@atlaskit/theme/colors';

export function FooterLogo() {
  return (
    <LogoWrapper>
      <AtlassianLogo
        textColor={B400}
        iconColor={B200}
        iconGradientStart={B400}
        iconGradientStop={B200}
        size={'xsmall'}
      />
    </LogoWrapper>
  );
}

const LogoWrapper = styled.div`
  width: min-content;
  margin: 0 auto;
`;
